import { JSONSchema7 } from 'json-schema';

const ReturnStepsLocationsSchema = async () => {
    let schema: JSONSchema7 = {
        title: 'EditedBySimpleTextSchema',
        type: 'object',
        //
        definitions: {},
    };
    //
    schema = {
        properties: {
            className: {
                type: 'string',
            },
        },
        //
        ...schema,
    };
    //
    return schema;
};

export default ReturnStepsLocationsSchema;
